import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";

type TInput = {
  id: number;
};

type TOutput = void;

export default class ActivateWatchdogApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.POST;

  resolveUri({ id }: TInput): string {
    return `/fe-api/watchdog/periodicity/${id}`;
  }

  mapRequestData() {
    return { frequency_id: "ASAP" };
  }
}
